export default class Competition {
  constructor (dataCompetition) {
    this.id = dataCompetition.id
    this.areaId = dataCompetition.areaId
    this.name = dataCompetition.nameFr
  }
}
